import React from "react";
import Navbar from "../components/Navbar";

function Login() {
  return (
    <div>
      <Navbar />
    </div>
  );
}

export default Login;
